import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';

function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === 'function') return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

import EventEmitter from 'events';
var DEFAULT_COUNTDOWN_TIME = 60;

function countdownHandler(isInit) {
    if (!isInit) {
        this.countdownTime -= 1000;
    }

    if (this.active) {
        this.__TIMEOUT_HANDLER__ = setTimeout(this.__COUNTDOWN_HANDLER__, 1000);
        this.emit('update', {
            type: 'update',
            value: this.countdownTime
        });
    } else {
        this.reset();
        this.emit('update', {
            type: 'update',
            value: 0
        });
        this.emit('timeout', {
            type: 'timeout'
        });
    }
}

var CountdownModel = /*#__PURE__*/ (function(_EventEmitter) {
    _inherits(CountdownModel, _EventEmitter);

    var _super = _createSuper(CountdownModel);

    function CountdownModel() {
        var _this;

        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$time = _ref.time,
            time = _ref$time === void 0 ? DEFAULT_COUNTDOWN_TIME : _ref$time;

        _classCallCheck(this, CountdownModel);

        _this = _super.call(this);
        _this.__IS_RUNNING__ = false;
        _this.__COUNTDOWN_TIME__ = time;

        _this.__COUNTDOWN_HANDLER__ = function(init) {
            countdownHandler.call(_assertThisInitialized(_this), init);
        };

        _this.setCurrent(time);

        return _this;
    }

    _createClass(CountdownModel, [
        {
            key: 'setCurrent',
            value: function setCurrent() {
                var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.__COUNTDOWN_TIME__;
                this.emit('update', {
                    type: 'update',
                    value: time
                });
                this.countdownTime = time;
            }
        },
        {
            key: 'reset',
            value: function reset() {
                this.setCurrent();
                return this.stop();
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.setCurrent();
                return this.pause();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                if (this.active) {
                    this.emit('pause');
                    clearTimeout(this.__TIMEOUT_HANDLER__);
                    this.__IS_RUNNING__ = false;
                }

                return this;
            }
        },
        {
            key: 'start',
            value: function start() {
                if (!this.active) {
                    this.emit('start');
                    this.__IS_RUNNING__ = true;

                    this.__COUNTDOWN_HANDLER__(true);
                }

                return this;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.pause();
                this.removeAllListeners();
                this.countdownTime = null;
                this.__IS_RUNNING__ = null;
                this.__COUNTDOWN_TIME__ = null;
                this.__COUNTDOWN_HANDLER__ = null;
            }
        },
        {
            key: 'active',
            get: function get() {
                return this.__IS_RUNNING__ && this.currentTime > 0;
            }
        },
        {
            key: 'currentTime',
            get: function get() {
                return this.countdownTime;
            }
        }
    ]);

    return CountdownModel;
})(EventEmitter);

export default CountdownModel;
